export default (function (element) {
  return (
    // $FlowFixMe: need to get type refinement work
    element.hasOwnProperty('jquery') ? element[0] : element
  );
});